import { useState } from 'react';

import NotificationsIcon from '@mui/icons-material/Notifications';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { IconButton } from 'shared/mui/IconButtons';
import { useGetNotificationsCount } from 'shared/widgets/Notification/hooks/useGetNotificationsCount';
import { NotificationsPopper } from 'shared/widgets/Notification/NotificationPopper/NotificationPopper';

import { NotificationCounter } from './NotificationButton.styled';

export const NotificationButton = (): JSX.Element => {
  const translate = useTypedTranslate();
  const { notificationsCount, refetch } = useGetNotificationsCount();

  const [anchorEl, setAnchorEl] = useState<Element | null>(null);

  const handleClick = (event: React.MouseEvent<Element>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        aria-label={translate('app.common.notifications')}
        color="inherit"
        onClick={handleClick}
        size="large"
        sx={{ padding: '8px', position: 'relative' }}
      >
        {!!Number(notificationsCount) && (
          <NotificationCounter>{notificationsCount}</NotificationCounter>
        )}
        <NotificationsIcon />
      </IconButton>
      <NotificationsPopper anchorEl={anchorEl} onClose={handleClose} refetchCounter={refetch} />
    </>
  );
};
